import { BlobWriter, Uint8ArrayReader, ZipWriter } from "@zip.js/zip.js";

export async function createZipStreamWriter() {
    const writer = new ZipWriter(new BlobWriter("application/zip"));
    let entries = 0;

    async function addTile(fileName, arrayBuffer) {
        await writer.add(fileName, new Uint8ArrayReader(new Uint8Array(arrayBuffer)));
        entries += 1;
    }

    async function close() {
        const blob = await writer.close();
        return {
            blob,
            entries
        };
    }

    return {
        addTile,
        close
    };
}
